

export class UserDiseaseMedicalStatistics{
    id : string;
    userNumber: string;
    fullName: string;
    fullNameEn: string;
    className: string;
    classNameEn: string;
    sectionName: string;
    sectionNameEn: string;
    results: number[]=[];

}